import Hub from 'models/hub';
export const GOT_HUB = 'got-hub';
const gotHub = ({ hub }) => ({
  type: GOT_HUB,
  payload: {
    hub: new Hub(hub),
  },
});
export default gotHub;
